module.exports = __webpack_public_path__ + "static/media/ic-contact-edit.47a462e1.svg";